import parsePhoneNumber, { isValidPhoneNumber } from "libphonenumber-js";

import regExp from "core-web/utils/regExp";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const useFormSubmit = ({ action, required = [], ignore = [] }) => {
    const { t } = useTranslation();
    const [error, setError] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [submittedForm, setSubmittedForm] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        // @todo: FormData does not work in IE
        const formData = new FormData(event.target);
        const errors = [];
        const inputs = [...event.target];
        const phoneInput =
            inputs.filter((input) => input.id === "phone_number")[0] ||
            inputs.filter((input) => input.id === "mobile_phone")[0];
        const customerLocale = phoneInput?.getAttribute("data-locale")?.toUpperCase();
        let data = {};

        // Extra validation for input fields that need more than html5 validation
        const validateInput = (name, value) => {
            // Check if reason is checked because html5 validation does not work on elements that are display none
            if ((name === "reason" || name === "state") && !selectedValue) {
                errors.push({
                    name,
                    message: t("utils.please_select_one"),
                });
            } else if (name.toLowerCase().includes("email") && name !== "remember_email") {
                !regExp.validation.correctEmail.test(value.toLowerCase()) &&
                    errors.push({
                        name,
                        message: t("utils.email_not_valid"),
                    });
            }

            if (
                (name === "phone_number" || name === "mobile_phone") &&
                (!customerLocale || !isValidPhoneNumber(value, customerLocale)) &&
                !isValidPhoneNumber(value)
            ) {
                errors.push({ name, message: t("utils.phone_not_valid") });
            }
        };

        const formatPhoneNumber = (number, locale) => parsePhoneNumber(number, locale).formatInternational();

        // Loop through formData, for each name/data and add to the data object
        for (const [name, value] of formData) {
            validateInput(name, value);
            const ignoreData = ignore.indexOf(name) !== -1;

            data = !ignoreData ? { ...data, [name]: value } : { ...data };
        }

        // Double check if every required item exists in data, e.g. is a checkbox checked
        required.forEach(
            (name) =>
                Object.keys(data).indexOf(name) >= 0 ||
                errors.push({
                    name,
                    message: t("utils.you_have_to_check_this"),
                }),
        );

        if (errors.length < 1) {
            setError([]);

            // We need to handle both of these since register and update take different names for phone number
            // Formats phone number before submitting it
            if (data.phone_number) {
                data.phone_number = formatPhoneNumber(data.phone_number, customerLocale);
            }
            if (data.mobile_phone) {
                data.mobile_phone = formatPhoneNumber(data.mobile_phone, customerLocale);
            }

            typeof action === "function" && action(data);

            // Hide form and show success message
            setSubmittedForm(true);
        } else {
            setError(errors);
        }
    };

    return {
        error,
        submittedForm,
        selectedValueArray: [selectedValue, setSelectedValue],
        handleSubmit,
        setError,
    };
};

export default useFormSubmit;
